// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compositeTextInput_EwqLG {
  font: normal 15px/24px Inter;
  color: var( --color-base700 );
  border: 1px solid var( --color-base200 );
  outline: none;
  display: flex;
  overflow: hidden;
  transition: background-color 0.2s,color 0.2s,transform 0.2s;
  align-items: center;
  border-radius: var( --size-small );
  flex-direction: row;
  background-color: var( --color-white );
}
.compositeTextInput_EwqLG > .input_neM52 {
  font: normal 15px/24px Inter;
  color: #394756;
  padding: var( --size-padSmall ) var( --size-padLarge );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.compositeTextInput_EwqLG > .input_neM52::placeholder {
  color: var( --color-base300 );
  font-size: var( --size-fontButtonMedium );
}
.compositeTextInput_EwqLG > .button_Mrt8Z {
  border-radius: 0px;
}
.compositeTextInput_EwqLG:focus-within {
  border-top-color: var( --color-brand400 );
  border-left-color: var( --color-brand400 );
  border-right-color: var( --color-brand400 );
  border-bottom-color: var( --color-brand400 );
}
.compositeTextInput_EwqLG[data-disabled=true] {
  color: var( --color-base300 );
  border-top-color: var( --color-base300 );
  border-left-color: var( --color-base300 );
  border-right-color: var( --color-base300 );
  border-bottom-color: var( --color-base300 );
}
.compositeTextInput_EwqLG[data-error=true] {
  border-top-color: var( --color-danger500 );
  border-left-color: var( --color-danger500 );
  border-right-color: var( --color-danger500 );
  border-bottom-color: var( --color-danger500 );
}
.compositeTextInput_EwqLG.compositeTextInput-small_WU0AA > .input_neM52 {
  padding: var( --size-small ) var( --size-medium );
  font-size: var( --size-fontButtonSmall );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO > .input_neM52 {
  padding-left: var( --size-padMedium );
  padding-right: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO > .button_Mrt8Z {
  height: 40px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO {
  height: 40px;
  display: flex;
  min-width: 450px;
  align-items: center;
  padding-left: var( --size-medium );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO[data-error=true] > .button_Mrt8Z {
  background-color: var( --color-danger500 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN > .button_Mrt8Z {
  width: 0px;
  margin: 0px;
  height: 0px;
  padding: 0px;
  background-color: transparent;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN {
  width: 100%;
  min-width: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-password_LcnYh > .button_Mrt8Z {
  color: var( --color-base500 );
  background-color: transparent;
}
.compositeTextInput_EwqLG.compositeTextInput-password_LcnYh > .button_Mrt8Z:hover {
  background-color: transparent;
}
.compositeTextInput_EwqLG.compositeTextInput-password_LcnYh {
  width: 100%;
  height: 40px;
}
.compositeTextInput_EwqLG.compositeTextInput-scan_rBySE {
  border: 1px solid var( --color-base200 );
  padding-left: var( --size-padSmall );
  padding-right: var( --size-padSmall );
}
.compositeTextInput_EwqLG.compositeTextInput-fullWidth_efMOm {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-formInput_mPDso {
  width: 100%;
  background-color: var( --color-white );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 > .input_neM52 {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 > .input_neM52[disabled] {
  color: var( --color-base300 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 > .button_Mrt8Z {
  width: 0px;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9 {
  border: 1.5px solid var( --color-base200 );
  margin-top: var( --size-medium );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9:focus-within {
  border-top-color: var( --color-brand300 );
  border-left-color: var( --color-brand300 );
  border-right-color: var( --color-brand300 );
  border-bottom-color: var( --color-brand300 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-attributeSelectorFilter_JAVA9[data-disabled=true] {
  background-color: var( --color-base100 );
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-formSearchBar_Qjdfs > .input_neM52 {
  width: 100%;
}
.compositeTextInput_EwqLG.compositeTextInput-search_UapoO.compositeTextInput-mobileSearch_jGwtN.compositeTextInput-formSearchBar_Qjdfs > .button_Mrt8Z {
  width: 0px;
  height: 0px;
}`, "",{"version":3,"sources":["webpack://./src/theme/CompositeTextInput.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,2DAA2D;EAC3D,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,sDAAsD;EACtD,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,iDAAiD;EACjD,wCAAwC;AAC1C;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;AACA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;AACb","sourcesContent":[".compositeTextInput {\n  font: normal 15px/24px Inter;\n  color: var( --color-base700 );\n  border: 1px solid var( --color-base200 );\n  outline: none;\n  display: flex;\n  overflow: hidden;\n  transition: background-color 0.2s,color 0.2s,transform 0.2s;\n  align-items: center;\n  border-radius: var( --size-small );\n  flex-direction: row;\n  background-color: var( --color-white );\n}\n.compositeTextInput > .input {\n  font: normal 15px/24px Inter;\n  color: #394756;\n  padding: var( --size-padSmall ) var( --size-padLarge );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.compositeTextInput > .input::placeholder {\n  color: var( --color-base300 );\n  font-size: var( --size-fontButtonMedium );\n}\n.compositeTextInput > .button {\n  border-radius: 0px;\n}\n.compositeTextInput:focus-within {\n  border-top-color: var( --color-brand400 );\n  border-left-color: var( --color-brand400 );\n  border-right-color: var( --color-brand400 );\n  border-bottom-color: var( --color-brand400 );\n}\n.compositeTextInput[data-disabled=true] {\n  color: var( --color-base300 );\n  border-top-color: var( --color-base300 );\n  border-left-color: var( --color-base300 );\n  border-right-color: var( --color-base300 );\n  border-bottom-color: var( --color-base300 );\n}\n.compositeTextInput[data-error=true] {\n  border-top-color: var( --color-danger500 );\n  border-left-color: var( --color-danger500 );\n  border-right-color: var( --color-danger500 );\n  border-bottom-color: var( --color-danger500 );\n}\n.compositeTextInput.compositeTextInput-small > .input {\n  padding: var( --size-small ) var( --size-medium );\n  font-size: var( --size-fontButtonSmall );\n}\n.compositeTextInput.compositeTextInput-search > .input {\n  padding-left: var( --size-padMedium );\n  padding-right: 0px;\n}\n.compositeTextInput.compositeTextInput-search > .button {\n  height: 40px;\n}\n.compositeTextInput.compositeTextInput-search {\n  height: 40px;\n  display: flex;\n  min-width: 450px;\n  align-items: center;\n  padding-left: var( --size-medium );\n}\n.compositeTextInput.compositeTextInput-search[data-error=true] > .button {\n  background-color: var( --color-danger500 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch > .button {\n  width: 0px;\n  margin: 0px;\n  height: 0px;\n  padding: 0px;\n  background-color: transparent;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch {\n  width: 100%;\n  min-width: 0px;\n}\n.compositeTextInput.compositeTextInput-password > .button {\n  color: var( --color-base500 );\n  background-color: transparent;\n}\n.compositeTextInput.compositeTextInput-password > .button:hover {\n  background-color: transparent;\n}\n.compositeTextInput.compositeTextInput-password {\n  width: 100%;\n  height: 40px;\n}\n.compositeTextInput.compositeTextInput-scan {\n  border: 1px solid var( --color-base200 );\n  padding-left: var( --size-padSmall );\n  padding-right: var( --size-padSmall );\n}\n.compositeTextInput.compositeTextInput-fullWidth {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-formInput {\n  width: 100%;\n  background-color: var( --color-white );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter > .input {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter > .input[disabled] {\n  color: var( --color-base300 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter > .button {\n  width: 0px;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter {\n  border: 1.5px solid var( --color-base200 );\n  margin-top: var( --size-medium );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter:focus-within {\n  border-top-color: var( --color-brand300 );\n  border-left-color: var( --color-brand300 );\n  border-right-color: var( --color-brand300 );\n  border-bottom-color: var( --color-brand300 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-attributeSelectorFilter[data-disabled=true] {\n  background-color: var( --color-base100 );\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-formSearchBar > .input {\n  width: 100%;\n}\n.compositeTextInput.compositeTextInput-search.compositeTextInput-mobileSearch.compositeTextInput-formSearchBar > .button {\n  width: 0px;\n  height: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"compositeTextInput": `compositeTextInput_EwqLG`,
	"input": `input_neM52`,
	"button": `button_Mrt8Z`,
	"compositeTextInput-small": `compositeTextInput-small_WU0AA`,
	"compositeTextInput-search": `compositeTextInput-search_UapoO`,
	"compositeTextInput-mobileSearch": `compositeTextInput-mobileSearch_jGwtN`,
	"compositeTextInput-password": `compositeTextInput-password_LcnYh`,
	"compositeTextInput-scan": `compositeTextInput-scan_rBySE`,
	"compositeTextInput-fullWidth": `compositeTextInput-fullWidth_efMOm`,
	"compositeTextInput-formInput": `compositeTextInput-formInput_mPDso`,
	"compositeTextInput-attributeSelectorFilter": `compositeTextInput-attributeSelectorFilter_JAVA9`,
	"compositeTextInput-formSearchBar": `compositeTextInput-formSearchBar_Qjdfs`
};
export default ___CSS_LOADER_EXPORT___;
